function AltRedundant() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>The alternative text for an image is the same as nearby or adjacent text.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Alternative text that is the same as nearby or adjacent text will be presented multiple times to screen readers or when images are unavailable.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Change either the alternative text or the adjacent text to eliminate the redundancy. In most cases, you can give the image empty/null alternative text (alt="") because the content of the image is already provided in context through text. Linked images may often be combined with the adjacent text into one link, in which case the image may be given null/empty alternative text (alt="").</p>
    </blockquote>
  )
}

export default AltRedundant